import { useContext, useEffect } from 'react'
import { v4 as uuidv4 } from 'uuid';
import {
  Box,
  Grid,
  Paper,
  Stack,
  Typography
} from '@mui/material'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import AiChatHelp from '../../components/right-panel/help/aiChat'
import { DataContext, DataDispatchContext } from '../../contexts/data/dataContext'
import FeedbackForm from './helpAndSupport/feedBackForm';
import ContactUs from './helpAndSupport/contactUs';
import custom from '../../styles/mui/szVariables.json'
import { analyticsPage, analyticsDomain, analyticsCta } from '../../services/constants'
import { sendClickAnalytics, sendViewAnalytics } from '../common/util/util'

export default function HelpAndSupport() {
  const border = custom.border;
  const data = useContext(DataContext)
  const dispatch: any = useContext(DataDispatchContext)
 
  const askAssistant = (id: number)=>{
    const question = data?.helpAndSupport?.faqs[id]
    sendClickAnalytics('/profile', {
        domain: analyticsDomain.profile,
        name: analyticsCta.customFaq,
        metadata: { faqIndex: id },
      })
    if(data?.rightPanel?.key!=='help') {
      dispatch({
        type: 'setRightPanel',
        rightPanel: <AiChatHelp key="help"/>
      })
    }
    dispatch({
      type: 'newAiConversation',
      message: question,
      from: 'user',
      chatWindow: data.chat.chatWindow + 5,
      key: uuidv4()
    })
    data.askAIhelp(question)
  }

  useEffect(()=>{
    sendViewAnalytics('/profile',{
            domain: analyticsDomain.profile,
            name: analyticsPage.helpAndSupport
          })
  },[])

  return (
    <Box 
    px={custom.spacing.md}
    pt={{
        xs: custom.spacing.xxl,
        sm: data?.rightPanel?custom.spacing.md:0,
        md: 0,
        lg: 0
    }}>
      <Grid container direction="row" 
          justifyContent="flex-start" 
          alignItems="flex-start" 
          spacing={custom.spacing.sm}
          pb={3}>
        <Grid item xs={12} sm={12} md={12} 
              lg={data?.rightPanel?12:8}>
          <Grid container direction="column" 
                justifyContent="flex-start" 
                alignItems="flex-start" 
                spacing={custom.spacing.sm}>
            <Grid item xs width='100%'>
              <Paper
                elevation={0}
                sx={{ 
                  borderRadius: custom.corners4, 
                  border, 
                  width: '100%', 
                  boxSizing: 'border-box' 
                }}>
                <Box width='100%'
                    pl={custom.spacing.md}
                    pr={custom.spacing.sm}
                    pt={custom.spacing.md}
                    pb={custom.spacing.xs}>
                  <Typography 
                      component={'h1'} 
                      variant="szHeading.Bold.Large">
                    Help and Support
                  </Typography>
               </Box>
               <Box m={custom.spacing.sm}>   
                  <Typography m={custom.spacing.sm}
                      component={'h3'} 
                      variant="szHeading.Bold.xSmall">
                    Frequently asked questions
                  </Typography>
                  {data?.helpAndSupport?.faqs?.map(
                    (faq: any, i: number) => (
                    <Box
                      sx={{
                        maxWidth: '100%',
                        py: custom.spacing.xs,
                        px: custom.spacing.sm,
                        cursor: 'pointer',
                        '&:hover': {
                          backgroundColor: 'sz.colors.hover',
                          boxShadow: 'none',
                        },
                      }}
                      id={`faqItem${i+1}`}
                      key={i}
                      onClick={()=>askAssistant(i)}>
                      <Stack direction="row" 
                        alignItems="center">
                        <Typography variant="szBody.Regular.Medium">
                          {faq}
                        </Typography>
                        <ArrowForwardIosIcon sx={{ 
                              marginLeft: 'auto', 
                              pt: custom.spacing.xxxs, 
                              height: '1rem' }} />
                      </Stack>
                    </Box>
                  ))}
                </Box>
              </Paper>
            </Grid>
            <Grid item xs width='100%'>
              <FeedbackForm />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12} 
              lg={data?.rightPanel?12:4}>
          <ContactUs />
        </Grid>
      </Grid>
    </Box> 
  )
}
